import type { Manifest as ManifestVTEX } from 'apps/vtex/manifest.gen.ts'
import type { Manifest as ManifestALGOLIA } from 'apps/algolia/manifest.gen.ts'
import type { Manifest } from './manifest.gen.ts'
import { proxy } from '@deco/deco/web'
export const Runtime = proxy<Manifest & ManifestVTEX & ManifestALGOLIA>()
export const invoke = Runtime
